import { Drawer, Button, Typography } from "antd";
import { Row, Col } from "antd";
import {
  formatNumberWithDots,
  calculateTimeDifference,
} from "../../helpers/utils";
import { formatTime, formatDateNoTime } from "../../helpers/formatDate";
import { isArray } from "lodash";
const { Text, Title } = Typography;

const TicketDetailsDrawer = ({
  visible,
  onClose,
  ticketDetails,
  airports,
  handleSelectTicket,
}) => {
  return (
    <Drawer placement="bottom" onClose={onClose} open={visible} height={"auto"}>
      <div className="p-4">
        <Title level={4}>
          {isArray(airports) &&
            airports?.find(
              (item) =>
                item.code ===
                ticketDetails.options?.[0]?.flights?.[0]?.startpoint
            )?.name}{" "}
          -{" "}
          {isArray(airports) &&
            airports?.find(
              (item) =>
                item.code === ticketDetails.options?.[0]?.flights?.[0]?.endpoint
            )?.name}
        </Title>
        <div
          className="p-4 rounded-[8px] flex flex-col gap-4"
          style={{
            border: "1px solid #EBEBF0",
          }}
        >
          <div className="flex gap-4 items-center">
            <img
              src={`${process.env.REACT_APP_BASE_URL}/${ticketDetails?.airline?.iconurl}`}
              alt="logo"
              style={{ width: "auto", height: 30 }}
            />
            <div className="flex flex-col justify-between">
              {" "}
              <Text className="text-[14px] text-[#808089]">
                {ticketDetails?.airline?.name}
              </Text>
              {ticketDetails.options?.[0]?.flights?.[0]?.segments?.map(
                (segment, index) => (
                  <Text className="text-[14px] text-[#808089]" key={segment.id}>
                    {ticketDetails.airline.code}
                    {segment.flightnumber} / {segment.fareclassname}
                  </Text>
                )
              )}
            </div>
          </div>
          <hr
            style={{
              border: "1px solid #EBEBF0",
            }}
          />
          <Row gutter={16} align={"middle"}>
            <Col span={8}>
              <h4 className="font-bold text-sm">
                {ticketDetails?.options?.[0]?.flights?.[0]?.startpoint}
              </h4>
              <p className="text-xs">
                {formatTime(
                  ticketDetails?.options?.[0]?.flights?.[0]?.startdate
                )}
              </p>
              <p className="text-xs">
                {formatDateNoTime(
                  ticketDetails?.options?.[0]?.flights?.[0]?.startdate
                )}
              </p>
            </Col>
            <Col span={8} className="justify-center text-center">
              <p className="text-xs text-[#808089]">
                {calculateTimeDifference(
                  ticketDetails?.options?.[0]?.flights?.[0]?.startdate,
                  ticketDetails?.options?.[0]?.flights?.[0]?.enddate
                )}
              </p>
              <img src="/images/flight-line.svg" alt="" />
              <p className="text-[10px] text-[#808089]">
                {ticketDetails?.options?.[0]?.flights?.[0]?.stopnum === 0
                  ? "Bay thẳng"
                  : `${ticketDetails?.options?.[0]?.flights?.[0]?.stopnum} điểm dừng`}
              </p>
            </Col>
            <Col span={8}>
              <h4 className="font-bold text-sm">
                {ticketDetails?.options?.[0]?.flights?.[0]?.endpoint}
              </h4>
              <p className="text-xs">
                {formatTime(ticketDetails?.options?.[0]?.flights?.[0]?.enddate)}
              </p>
              <p className="text-xs">
                {formatDateNoTime(
                  ticketDetails?.options?.[0]?.flights?.[0]?.enddate
                )}
              </p>
            </Col>
          </Row>
        </div>
        <div className="flex flex-col gap-2 px-4">
          <Row justify="space-between mt-4">
            <Text>{ticketDetails.adt} Người lớn</Text>
            <Text>
              {formatNumberWithDots(ticketDetails?.priceadt)}{" "}
              {ticketDetails.currency}
            </Text>
          </Row>
          <Row justify="space-between">
            <Text>{ticketDetails.chd} Trẻ em</Text>
            <Text>
              {formatNumberWithDots(ticketDetails?.pricechd)}{" "}
              {ticketDetails.currency}
            </Text>
          </Row>
          <Row justify="space-between ">
            <Text>{ticketDetails.inf} Em bé</Text>
            <Text>
              {formatNumberWithDots(ticketDetails?.priceinf)}{" "}
              {ticketDetails.currency}
            </Text>
          </Row>
          <Row justify="space-between">
            <Text>Thuế</Text>
            <Text>Đã bao gồm</Text>
          </Row>
          <Row justify="space-between">
            <Text>Hành lý xách tay</Text>
            <Text>
              {
                ticketDetails?.options?.[0]?.flights?.[0]?.segments?.[0]
                  ?.handbaggage
              }
            </Text>
          </Row>
          <Row justify="space-between">
            <Text>Thủ tục ưu tiên</Text>
            <Text>0 {ticketDetails.currency}</Text>
          </Row>
          <Row justify="space-between">
            <Text>Giảm giá</Text>
            <Text style={{ color: "green" }}>0 {ticketDetails.currency}</Text>
          </Row>
          <Row justify="space-between">
            <Text strong>Tổng số tiền</Text>
            <Text strong style={{ fontSize: "18px" }} className="text-primary">
              {formatNumberWithDots(ticketDetails?.totalprice)}{" "}
              {ticketDetails.currency}
            </Text>
          </Row>
        </div>
        <Button
          onClick={() => handleSelectTicket(ticketDetails)}
          type="primary"
          className="w-full h-[48px] mt-6"
        >
          Chọn vé
        </Button>
      </div>
    </Drawer>
  );
};

export default TicketDetailsDrawer;
